function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import { convertPurchaseToTransactionFormat } from 'researcher/digital-orders/reducer';
import * as c from './constants';
var initialState = {
  availableDigitalPurchases: [],
  digitalEditingPurchase: null,
  digitalEdits: [],
  digitalPurchases: [],
  hasDigitalEditingPurchase: false,
  hasUploadedDigitalEdit: true,
  pagination: {},
  status: {
    downloadingFiles: [],
    retrievingDownload: false,
    searchBusy: false,
    searchCompleted: false
  }
};
var digitalEditColor = function digitalEditColor(digitalEdit) {
  switch (digitalEdit.status) {
    case c.STATUSES.STATUS_COMPLETED:
      return '#42b22b';
    case c.STATUSES.STATUS_FAILED:
      return '#b4172b';
    default:
      return '#d6d6d6';
  }
};
export var getDigitalEdits = createSelector(function (_ref) {
  var digitalEdit = _ref.digitalEdit;
  return digitalEdit.digitalEdits;
}, function (digitalEdits) {
  return digitalEdits.map(function (digitalEdit) {
    return _objectSpread(_objectSpread({}, digitalEdit), {}, {
      color: digitalEditColor(digitalEdit),
      completed: digitalEdit.status === c.STATUSES.STATUS_COMPLETED,
      finishedProcessing: digitalEdit.status !== c.STATUSES.STATUS_PROCESSING,
      failed: digitalEdit.status === c.STATUSES.STATUS_FAILED,
      processing: digitalEdit.status === c.STATUSES.STATUS_PROCESSING,
      createdAt: moment(digitalEdit.createdAt).format('YYYY-MM-DD'),
      fileType: "file-type-".concat(digitalEdit.file.name.split('.').pop().toLowerCase())
    });
  });
});

/**
 * Returns the sum of totalEdits across all completed editing documents
 * in the current page. Used by the trial usage banner.
 *
 * Each document carries a `totalEdits` field populated from the FAC API
 * `total_edits` value and surfaced by the backend search endpoint.
 * Falls back to 0 if the field is absent (e.g. older documents or
 * documents still processing).
 */
export var getTotalEditsForTrialBanner = createSelector(function (_ref2) {
  var digitalEdit = _ref2.digitalEdit;
  return digitalEdit.digitalEdits;
}, function (digitalEdits) {
  return digitalEdits.reduce(function (sum, doc) {
    var _doc$totalEdits;
    if (doc.status !== c.STATUSES.STATUS_COMPLETED) return sum;
    return sum + ((_doc$totalEdits = doc.totalEdits) !== null && _doc$totalEdits !== void 0 ? _doc$totalEdits : 0);
  }, 0);
});

/**
 * Returns { documentCount, totalEdits, ready } for the trial usage banner,
 * where BOTH values are derived from the same set of docs: only completed
 * documents that have a confirmed (non-null) totalEdits from the API.
 *
 * This keeps the two counts in sync — a document is not counted toward
 * documentCount until its totalEdits value has also arrived, preventing
 * the "2 documents, 0 changes" interim state.
 */
export var getTrialBannerCounts = createSelector(function (_ref3) {
  var digitalEdit = _ref3.digitalEdit;
  return digitalEdit.digitalEdits;
}, function (_ref4) {
  var digitalEdit = _ref4.digitalEdit;
  return digitalEdit.status.searchCompleted;
}, function (digitalEdits, searchCompleted) {
  var readyDocs = digitalEdits.filter(function (doc) {
    return doc.status === c.STATUSES.STATUS_COMPLETED && doc.totalEdits != null;
  });
  return {
    ready: searchCompleted && readyDocs.length > 0,
    documentCount: readyDocs.length,
    totalEdits: readyDocs.reduce(function (sum, doc) {
      return sum + doc.totalEdits;
    }, 0)
  };
});

/**
 * Returns true only when at least one completed document has a confirmed
 * totalEdits value (not null/undefined) from the API. This is used to gate
 * the trial usage banner so it never renders with placeholder "0 changes"
 * while documents are still processing or before the first API response.
 */
export var getTrialBannerDataReady = createSelector(function (_ref5) {
  var digitalEdit = _ref5.digitalEdit;
  return digitalEdit.digitalEdits;
}, function (_ref6) {
  var digitalEdit = _ref6.digitalEdit;
  return digitalEdit.status.searchCompleted;
}, function (digitalEdits, searchCompleted) {
  if (!searchCompleted) return false;
  return digitalEdits.some(function (doc) {
    return doc.status === c.STATUSES.STATUS_COMPLETED && doc.totalEdits != null;
  });
});
export var getDigitalEdit = createSelector(getDigitalEdits, function (_ref7) {
  var match = _ref7.match;
  return match.params.identity;
}, function (digitalEdits, identity) {
  return digitalEdits.find(function (digitalEdit) {
    return digitalEdit.identity === identity;
  });
});
export var getPreviousUrl = createSelector(function (_ref8) {
  var location = _ref8.location;
  return location.state || {
    pathname: null
  };
}, function (_ref9) {
  var pathname = _ref9.pathname;
  return pathname || '/researcher/digital-editing';
});
export var getAccessType = createSelector(function (_ref10) {
  var digitalEdit = _ref10.digitalEdit;
  return digitalEdit.hasDigitalEditingPurchase;
}, function (hasDigitalEditingPurchase) {
  if (hasDigitalEditingPurchase) {
    return c.ACCESS_TYPE.DIGITAL_PURCHASE;
  }
  return c.ACCESS_TYPE.NONE;
});
export var getNewPurchaseStartDate = createSelector(function (_ref11) {
  var digitalEdit = _ref11.digitalEdit;
  return digitalEdit.digitalEditingPurchase;
}, function (digitalEditingPurchase) {
  if (!digitalEditingPurchase || moment().isSameOrAfter(moment(digitalEditingPurchase.endsAt))) {
    return undefined;
  }
  return digitalEditingPurchase.endsAt;
});
export var getAvailableDigitalEditingPurchase = createSelector(function (_ref12) {
  var digitalEdit = _ref12.digitalEdit;
  return digitalEdit.availableDigitalPurchases;
}, function (availableDigitalPurchases) {
  return availableDigitalPurchases.find(function (_ref13) {
    var type = _ref13.type;
    return type === 'editing';
  });
});
export var getPurchaseInformation = createSelector(function (_ref14) {
  var digitalEdit = _ref14.digitalEdit;
  return digitalEdit.availableDigitalPurchases;
}, function (_ref15) {
  var digitalEdit = _ref15.digitalEdit;
  return digitalEdit.digitalPurchases;
}, function (_ref16) {
  var match = _ref16.match;
  return match.params.receiptCode;
}, function (_ref17) {
  var application = _ref17.application;
  return application.companyShortName;
}, convertPurchaseToTransactionFormat);
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_EDIT_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchBusy: false,
        searchCompleted: true
      });
    case c.DIGITAL_EDIT_SEARCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchBusy: true
      });
    case c.DOWNLOAD_URL_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        retrievingDownload: true,
        downloadingFiles: [].concat(_toConsumableArray(state.downloadingFiles), [action.digitalEditIdentity])
      });
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        retrievingDownload: false,
        downloadingFiles: _.pull(state.downloadingFiles, action.digitalEditIdentity)
      });
    default:
      return state;
  }
};
var digitalEdits = function digitalEdits() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.digitalEdits;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_EDIT_ARCHIVED:
      return state.filter(function (ae) {
        return ae.identity !== action.digitalEditIdentity;
      });
    case c.DIGITAL_EDIT_SEARCH_COMPLETED:
      return action.digitalEdits;
    case c.DIGITAL_EDITS_UPDATED:
      return state.map(function (digitalEdit) {
        var updated = action.digitalEdits[digitalEdit.identity];
        return updated ? _objectSpread(_objectSpread({}, digitalEdit), updated) : digitalEdit;
      });
    default:
      return state;
  }
};
export var digitalEditReducer = function digitalEditReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_EDIT_ARCHIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalEdits: digitalEdits(state.digitalEdits, action)
      });
    case c.DIGITAL_EDIT_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalEdits: digitalEdits(state.digitalEdits, action),
        pagination: action.pagination,
        status: status(state.status, action)
      });
    case c.DIGITAL_EDITS_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalEdits: digitalEdits(state.digitalEdits, action)
      });
    case c.DIGITAL_EDIT_SEARCH_REQUESTED:
    case c.DOWNLOAD_URL_REQUESTED:
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.DIGITAL_EDIT_DISPLAY_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        availableDigitalPurchases: action.availableDigitalPurchases,
        digitalEditingPurchase: action.digitalEditingPurchase,
        digitalPurchases: action.digitalPurchases,
        hasDigitalEditingPurchase: action.hasDigitalEditingPurchase,
        hasUploadedDigitalEdit: action.hasUploadedDigitalEdit
      });
    default:
      return state;
  }
};
export default digitalEditReducer;